import { styled } from 'styled-components';
export const CardIcon = styled.img.withConfig({
  displayName: "CardIcon",
  componentId: "asurion-ui-react__sc-1ha3x6g-0"
})(["min-height:1.5rem;min-width:2.375rem;height:", "rem;width:", "rem;padding:1rem 0;box-sizing:content-box;.is-disabled &{opacity:0.3;}"], props => props.height ?? 1.5, props => props.width ?? 2.375);